<template>
    <Modal
    v-if="isModalOpen === true"        
    :isOpen="isModalOpen"
    :changeModalState="changeModalState"
    :modalTitle="$t('general.order_details')"
    :hideHeadersBorder="true"
    :centeredTitle="true"
    rounded="30px"
    >
<div class=" p-[50px]">
    <div>
                  <!-- product image and name  -->
                  <div class=" flex gap-[35px] p-[22px] border border-[#D1D1D1] rounded-[10px] mb-[27px]">
                <div class="">
                    <img class="h-[115px] aspect-square object-cover rounded-[4px]"
                        :src="productData.image" alt="">
                </div>
                <span>{{ productData[`name_${currentLanguage}`] || '' }}</span>
            </div>
    </div>
    <div class=" mb-4">
  <div  v-for="offerItem in offerDetailsArray" :key="offerItem.id"


            class=" mb-2 flex flex-wrap items-center py-3 px-4 gap-1.5 md:gap-2 text-[0.8rem] md:text-[0.9rem] lg:text-[1rem] 3xl:text-[1.125rem] bg-primaryLight3 text-primary rounded-[0.625rem]">
           

            <RadioBtn title=""
                                :toShow="offerItem.isSelected"
                                @fun="changeState(offerItem.id)" />
            <span @click="changeState(offerItem.id)" class="cursor-pointer">
                {{ $t('user.offer_description_pt1', { quantity: arabizeNumbers(offerItem.quantity) }) }}
            </span>
            <span @click="changeState(offerItem.id)" class="cursor-pointer text-primary">
                {{ $t('user.offer_description_pt2', {
                  newPrice:
                    branchDiscount !== 0 ?
                    arabizeNumbers( Math.ceil(
                        this.productData.discount ?
                        offerItem.new_price * (1 - parseFloat(this.productData.discount) / 100) * (1 - branchDiscount) :
                        offerItem.new_price * (1 - branchDiscount)
                    ) ) :
                    arabizeNumbers(Math.ceil(
                        this.productData.discount ?
                        offerItem.new_price * (1 - parseFloat(this.productData.discount) / 100) :
                        offerItem.new_price
                    ))
                }) }}
            </span>
            <span @click="changeState(offerItem.id)" class="cursor-pointer">
                {{ $t('user.offer_description_pt3') }}
            </span>
            <span @click="changeState(offerItem.id)" class="cursor-pointer text-[#FF1F00] discount-line after:bg-[#FF1F00]">
                {{ arabizeNumbers(offerItem.old_price) }}
            </span> {{ " " }}
            <span @click="changeState(offerItem.id)" class="cursor-pointer text-[#FF1F00]">
                {{ $t('general.egy_pounds') }}
            </span>
          
        
        </div>

        <div class=" mt-6 flex flex-col items-center text-center w-full gap-3 lg:flex-row-reverse">
      

                  <!-- return button -->
                  <button type="button"
                 @click="changeModalState(false)"
                      class=" px-[40px] flex justify-center items-center border border-primary text-primary rounded-[7px] h-[55px] w-full lg:w-fit hover:opacity-60 ">
 
                      <span> {{ $t("general.ignore") }}
                      </span>
                  </button>

                          <!-- confirm button  -->
                
                <button type="submit"
                  @click="confirmActionForAddOffer"
                      class="flex-1 text-white w-full font-medium rounded-md text-[1rem] px-5 py-2 h-[55px] focus:outline-none disabled:bg-[#2d4671] disabled:hover:bg-[#2d4671] bg-primary hover:bg-blue-800">
                      {{ $t("general.ordering") }}
                  </button>
              </div>
</div>
</div>

    </Modal>
</template>

<script>
import Modal from '~/components/generic/Modal.vue';
import  {arabizeNumbers} from "@/helpers";
import RadioBtn from '~/components/generic/RadioBtn.vue';
import { useGlobalStore } from '../../../store/Modules/global.js';
import Branches from '~/pages/reseller/branches.vue';

export default {
    setup(){
        const globalStore = useGlobalStore();
        return {globalStore}
    },
    components:{
        Modal,
        RadioBtn
    },
    props:{
        offerDetailsArray:[],
        productData:{}
    },
    data() {
        return {
            isModalOpen:true,
            chosenOffer:{},
            offerDetailsArray:this.offerDetailsArray,
            productData:this.productData,
            currentLanguage:useGlobalStore()?.localStorageCopy?.language || 'ar',
            isNewOrder:true,
            maxQuantity:0,
            branchDiscount: 0,
        }
    },
    methods:{
        confirmActionForAddOffer(){
            if (!this.offerDetailsArray.some(item => item.isSelected)) {
                this.notify({type:'error',msg:this.$t('general.select_offer')});
                return;
            }
            this.offerDetailsArray = this.offerDetailsArray.map((item)=>{
                if(item.isSelected){
                    this.maxQuantity = item.quantity;
                }
                return item;
            })
            this.chosenOffer = this.offerDetailsArray.find((item)=>item.isSelected);
            this.$emit('confirmActionForAddOffer',{maxQuantity:this.maxQuantity, chosenOffer:this.chosenOffer});
        },
        arabizeNumbers,
        changeModalState(val){
            this.isModalOpen = val;
        },
        changeState(id){
            this.offerDetailsArray = this.offerDetailsArray.map((item)=>{
                if(item.id == id){
                    item.isSelected = true;
                    this.chosenOffer = item;
                }else{
                    item.isSelected = false
                }
                return item;
            })
        }
    },mounted(){
        if(localStorage.getItem('branch') !== "main"){
            const branch = JSON.parse(localStorage.getItem('branch'));
            this.branchDiscount = Math.abs(branch.discount) / 100;
        }else{
            this.branchDiscount = 0;
        }
        // reset the maxQuantity
        this.maxQuantity = 0;
        // reset the chosenOffer
        this.chosenOffer = {};
        // reset the selected state of the offerDetailsArray
        this.offerDetailsArray = this.offerDetailsArray.map((item)=>{
            item.isSelected = false;
            return item;
        })
        this.productData = useGlobalStore().productData;
    }


}
</script>

<style>

</style>